import React, {useEffect, useState} from "react";

import {Formik, FormikHelpers} from "formik";
import {Field, Form, FormRow} from "../../designSystem/Form";
import {validateMandatory} from "../../utils/formUtils";
import {Button} from "../../designSystem/Button";
import Container from "../Container";
import {getDisciplines, getActivities} from "../../services/controllers";
import {APIGetDisciplinesResponse, APIGetActivitiesResponse, Discipline, Activity} from "../../services/facade";
import {scrollToTop} from "../../utils/utils";
import Loader from "../../designSystem/Loader";

export interface SailingInfosFormProps {
  titleNumber?: number;
  initialValues: SailingInfosFormValues;
  setValues: (values: SailingInfos) => void;
  setValidated: (b: boolean) => void;
  isValidated?: boolean;
}

export interface  SailingInfos {
    discipline: Discipline,
    activity: Activity,
    handi?: boolean
}
export interface SailingInfosFormValues {
    discipline: string;
    level: string;
    handi?: string;
}


const SailingInfosForm = (props: SailingInfosFormProps) => {

    const [close, setClose] = useState<boolean>(false)
    const [validated, setValidated] = useState<boolean>(!!props.isValidated)
    const [activities, setActivities] = useState<Activity[]>([])
    const [disciplines, setDisciplines] = useState<Discipline[]>([])

    useEffect(() => {
        getActivities().then((data: APIGetActivitiesResponse) => setActivities(data.activities))
        getDisciplines().then((data: APIGetDisciplinesResponse) => setDisciplines(data.disciplines))
    }, [])

    const isLoading = activities.length === 0 || disciplines.length === 0

    return (
        <Container
            id={"SailingInfosFormContainer"}
            containerTitle={"Pratique de la voile"}
            titleNumber={props.titleNumber}
            close={close}
            setClose={() => setClose(!close)}
            validated={validated}
        >
            {!isLoading ? (
                <Formik
                    initialValues={props.initialValues}
                    onSubmit={(
                        values: SailingInfosFormValues,
                        { setSubmitting }: FormikHelpers<SailingInfosFormValues>
                    ) => {
                        setSubmitting(false);
                        props.setValues({
                            discipline: disciplines.filter((d: Discipline) => d.SECTEUR_CODE === values.discipline)[0],
                            activity: activities.filter((l: Activity) => l.code === values.level)[0],
                            handi: values.handi !== undefined ? values.handi === "true" : undefined,
                        });
                        setClose(true);
                        setValidated(true);
                        props.setValidated(true);
                        scrollToTop("SailingInfosFormContainer")();
                    }}
                >
                    <Form>
                        <FormRow>
                            <Field
                                id={"discipline"}
                                name={"discipline"}
                                as={"select"}
                                validate={validateMandatory}
                                label={"Pratique principale"}
                                onChange={() => {setValidated(false)}}
                            >
                                <option key={"empty"} value={""}>--</option>
                                {disciplines.sort(
                                    (a: Discipline, b: Discipline) => a.SECTEUR_LIBELLE > b.SECTEUR_LIBELLE ? 1 : -1
                                ).map(
                                    (d: Discipline) => <option key={d.SECTEUR_CODE} value={d.SECTEUR_CODE}>{d.SECTEUR_LIBELLE}</option>
                                )}
                            </Field>
                            <Field
                                id={"level"}
                                name={"level"}
                                as={"select"}
                                validate={validateMandatory}
                                label={"Activité"}
                                onChange={() => {setValidated(false)}}
                            >
                                <option key={"empty"} value={""}>--</option>
                                {activities.map(
                                    (l: Activity) => <option key={l.code} value={l.code}>{l.lib}</option>
                                )}
                            </Field>
                        </FormRow>
                        <Field
                            id={"handi"}
                            name={"handi"}
                            type="radioYN"
                            label={"Le pratiquant est-il en situation de handicap ?"}
                            explication={"Votre réponse est utilisée à des fins statistiques afin d’organiser et de valoriser la pratique Handivoile"}
                            optional
                            onChange={() => {setValidated(false)}}
                        />
                        <div className={"flex items-center justify-center md:justify-end"}>
                            <Button disabled={validated} type="submit">Confirmer</Button>
                        </div>
                    </Form>
                </Formik>
            ) : <div className={"h-10 w-full flex justify-center text-black"}><Loader /></div>}
        </Container>
    )
}

export default SailingInfosForm;